import {getDominantBlockType, withX, withType, getBlocks} from '../calculateRules.js';
import {byX} from './utils.js';
import {doc} from './docs.js';

doc(
    "shift",
    {
        "blockNumber": "block to shift"
    },
    "Shifts a block in grid by 1 to the right"
);
export const shift =  (grid, blockNumber) => {
    let amount = 1;
    let {cells, size} = grid;
    let blocks = getBlocks(cells, size);

    let block = blocks[blockNumber % blocks.length];

    if (!block) {
        return;
    }


    let type = getDominantBlockType(block, cells);
    block = fillBlock(cells, block);
    block = block.filter(({x,y}) => cells[y][x] !== type);
    if (block.length === 0) {
        return;
    }

    let next = cells[block[0].y][block[0].x];
    for (let i=0; i < block.length; i+=amount){
        let a = block[i];
        let b = block[(i+amount)%block.length];
        let _next = cells[b.y][b.x];
        if (cells[b.y][b.x-1]) {
            if (cells[b.y][b.x-2] === '-') {
                next = cells[b.y+1][b.x - 1];
            } else {
                next = cells[b.y][b.x - 1];
            }
        }
        cells[b.y][b.x] = next;
        next = _next;
    }
    grid.updateRedux();
    grid.calculateRules();
};
 

const fillCell = (cells, toAdd, block, x, y, maxX) => {
       // scan unntil maxX or other block
    for (let i=x; i < maxX; i++) {
        if (cells[y][i-1] === '-') {
            continue;
        }
        if (!cells[y][i] && !toAdd.some(p => p.x === i && p.y === y) && !block.some(p => p.x === i && p.y ===y)) {
            toAdd.push({x: i, y});
        }
    }
};

const fillBlock = (cells, block) => {
    let blockByX = byX(block);
    let xValues = Object.keys(blockByX).map(k => parseInt(k));
    let maxX = Math.max(... xValues);

    let toAdd = [];
    for (let piece of block) {
        let {x,y} = piece;
        if (cells[y][x] === '-') {
            fillCell(cells, toAdd, block, x, y+1, Math.max(x+2,maxX));
            fillCell(cells, toAdd, block, x+2, y, Math.max(x+3,maxX));
        } else {
            fillCell(cells, toAdd, block, x, y, maxX);
        }
    }

    let newBlock = [... block, ... toAdd];
    newBlock.sort((a,b) => a.x - b.x);
    return newBlock;
};
